import ManualDelete from './ManualDelete'
export {ManualDelete}
export default ManualDelete
